document.querySelectorAll('.premium-register-container .accept-button').forEach((target) => {
  target.addEventListener('click', function (e) {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((res) => {
        localStorage.setItem('cartItems', JSON.stringify(res.items));
        const itemUpdate = res.items.reduce((obj, item) => Object.assign(obj, { [item.id]: 0 }), {});
        itemUpdate[variant_id_premium_product] = 1;
        fetch('/cart/clear.js', { method: 'POST' })
          .then(() => {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [
                  {
                    quantity: 1,
                    id: variant_id_premium_product,
                    selling_plan: premium_product_selling_plan,
                  },
                ],
              }),
            })
              .then(() => {
                window.location.href = '/cart';
              })
              .catch(() => {});
          })
          .catch(() => {});
      })
      .catch(() => {});
  });
});

document.querySelectorAll('.about-button, .brand-block-concept-with-image-external-button').forEach((target) => {
  if (target.innerText == 'プレミアム会員に登録する') {
    target.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelectorAll('.premium-register-container').forEach((container) => {
        document.body.appendChild(container); // body直下に移動
        container.style.display = 'flex';
      });
    });
  }
});

document.querySelectorAll('.premium-register-container').forEach((target) => {
  target.addEventListener('click', function (e) {
    document.querySelectorAll('.premium-register-container').forEach((el2) => (el2.style.display = 'none'));
  });
});

document.querySelectorAll('.close-button').forEach((btn) => {
  btn.addEventListener('click', function (e) {
    document.querySelectorAll('.premium-register-container').forEach((el) => (el.style.display = 'none'));
  });
});
